import { createCustomEnum } from "./customEnum";

const ReportRepositories = createCustomEnum({
	OperationsManagement: {
		value: 1,
		name: "operations_management",
		displayName: "Operations Management",
	},
	Applications: {
		value: 2,
		name: "applications",
		displayName: "Applications",
	},
	Underwriting: {
		value: 3,
		name: "underwriting",
		displayName: "Underwriting",
	},
	CreditExposureAndRisk: {
		value: 4,
		name: "credit_exposure_and_risk",
		displayName: "Credit Exposure and Risk",
	},
	Boarding: {
		value: 5,
		name: "boarding",
		displayName: "Boarding",
	},
});

export default ReportRepositories;
